import {CLStore} from 'common/src/redux/store';
import {ChatType} from '../copilot.enums';
import createChat from '../store/actions/createChat';

// this must be called only after ALL agents have been registered, otherwise the chat may not have all the agents
export default function initializeCopilotChat(store: CLStore) {
  store.dispatch(createChat(ChatType.General));
}
